export default __webpack_public_path__ + "static/media/12_Business-ProductArchitecture-InteriorEschweilerPhotography_M1A7563.bfa87a4a.jpg";